{
  "name": "order-portal",
  "version": "1.1.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration production && npm run sentry:sourcemaps",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org ticketteam --project orderportal ./dist/Order && sentry-cli sourcemaps upload --org ticketteam --project orderportal ./dist/Order"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.14",
    "@angular/cdk": "^21.2.12",
    "@angular/common": "^21.2.14",
    "@angular/compiler": "^21.2.14",
    "@angular/core": "^21.2.14",
    "@angular/forms": "^21.2.14",
    "@angular/material": "^21.2.12",
    "@angular/platform-browser": "^21.2.14",
    "@angular/platform-browser-dynamic": "^21.2.14",
    "@angular/router": "^21.2.14",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-regular-svg-icons": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.8.2",
    "@ngrx/signals": "^21.1.0",
    "@ngx-translate/core": "^16.0.0",
    "@ngx-translate/http-loader": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^10.53.1",
    "@sentry/cli": "^3.4.2",
    "@tailwindcss/postcss": "^4.3.0",
    "@ticket-team-com/tt-component-library": "^2.5.1",
    "date-fns": "^2.30.0",
    "jspdf": "^4.2.1",
    "ngx-toastr": "^19.0.0",
    "qrcode": "^1.5.1",
    "rxjs": "~7.8.0",
    "sync-request": "^6.1.0",
    "tailwindcss": "^4.3.0",
    "tslib": "^2.0.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.12",
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/cli": "^21.2.12",
    "@angular/compiler-cli": "^21.2.14",
    "@angular/language-service": "^21.2.14",
    "@angular/localize": "^21.2.14",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/npm": "^12.0.1",
    "@types/jasmine": "~4.3.2",
    "@types/jasminewd2": "^2.0.10",
    "@types/jquery": "^3.5.14",
    "@types/node": "^18.0.0",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "bootstrap": "^4.6.2",
    "eslint": "^8.57.0",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~7.0.0",
    "jquery": "^3.6.1",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "protractor": "~7.0.0",
    "puppeteer": "^25.3.0",
    "semantic-release": "^24.2.5",
    "ts-node": "~7.0.0",
    "typescript": "5.9.3"
  }
}
